import { GET_ARMOUR_TYPES_SUCCESS } from "../actionTypes";

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_ARMOUR_TYPES_SUCCESS: {
      const armourTypes = action.payload;

      if (!armourTypes){
        return [...state];
      }

      return [
        ...state,
        ...armourTypes
      ]
    }
    default:
      return state;
  }
}
